<div class="search-builder-wrapper">
  <app-search-builder
    #searchBuilder
    [feed]="feed"
    [ctrlEnterExtension]="ctrlEnterExtension"
    (componentDataChange)="onDataChange($event)"
    (formGroupChange)="onFormGroupChange($event)"
    (builderChanged)="onBuilderChange($event)"
  ></app-search-builder>
</div>
